import type { DocumentViewResponse } from "../types/reportTemplate";
import type { OrganMapPhoto } from "../components/pathologist-review/ReportPhotoContent";
import { compositionReportData } from "./reportComposition";

export function partitionAddendumReportPhotos(
  photos: OrganMapPhoto[],
  data?: DocumentViewResponse
) {
  const ids = new Set(
    data
      ? (compositionReportData(data).addendums || []).flatMap(
          (entry) => entry.reportPhotoIds || []
        )
      : []
  );
  return {
    main: photos.filter((photo) => !ids.has(photo.image.id)),
    addendum: photos.filter((photo) => ids.has(photo.image.id)),
  };
}
